import { useState, useEffect } from "react";
import HttpStatus from 'http-status-codes';
import IconButton from "./IconButton";
import { getTracking } from 'service/OrderService';
import * as Lib from 'utils/Lib';


function TrackingDetail({
  visible = false, 
  orderUid = null,
  courier = null, 
  waybill = '',
  onClose = () => {}
}) {

  const [shippingStatus, setShippingStatus] = useState(null);
  const [driverName, setDriverName] = useState(null);
  const [driverPhone, setDriverPhone] = useState(null);
  const [driverPlate, setDriverPlate] = useState(null);
  const [trackingUrl, setTrackingUrl] = useState(null);

  const [history, setHistory] = useState([]);




  useEffect(() => {

    if(visible){

      document.body.setAttribute('style', 'overflow: hidden;');   // disabled scroll while showing preview.
      
      getTracking(orderUid, courier, waybill, 
        (status, body) => {

          // TODO: handler error and empty result

          if(status === HttpStatus.OK){

            const trackingData = body.data;

            console.log(trackingData);

            setShippingStatus(trackingData.shippingStatus);
            setDriverName(trackingData.courierName);
            setDriverPhone(trackingData.courierPhone);
            setDriverPlate(trackingData.courierLicensePlate);
            setTrackingUrl(trackingData.trackingUrl);
            setHistory(body.data.historyList);
          }



        });
    }
    else{
      document.body.setAttribute('style', 'overflow: auto;');
    }

  }, [visible]);


  const handleClose = () => {
    onClose();
  }



  const renderDot = (arr, i) => {
    if(i === 0){    // first index
      return(
        <div className="relative h-full">
          
          {arr.length > 1 && <div className="dotline absolute bg-green-200 h-full"></div>}
          <div className="dot bg-green-200 rounded-full"></div>
        </div>
      );
    }
    else if(i === (arr.length -1)){   // last index
      return(
        <div className="relative h-full">
          <div className="dot bg-green-200 rounded-full"></div>
        </div>
      );
    }
    else {
      return(
        <div className="relative h-full">
          <div className="dotline absolute bg-green-200 h-full"></div>
          <div className="dot bg-green-200 rounded-full"></div>
        </div>
      );
    }
  }


  const renderDriverInfo = () => (
    <div className="mb-10">
      <div className="font-bold mb-2">Info Driver</div>

      <div className="flex flex-row mb-2 text-sm">
        <div className="text-gray-400 w-24">Nama</div>
        <div className="font-bold">{driverName}</div>
      </div>
      {
        driverPhone !== null &&
        <div className="flex flex-row mb-2 text-sm">
          <div className="text-gray-400 w-24">No. telp</div>
          <div className="font-bold">{driverPhone}</div>
        </div>
      }
      {
        driverPlate !== null &&
        <div className="flex flex-row mb-2 text-sm">
          <div className="text-gray-400 w-24">Plat</div>
          <div className="font-bold">{driverPlate}</div>
        </div>
      }
    </div>
  );

  const renderLiveTrackingButton = () => (
    <div className="w-full text-center">
      <a className="inline-block bg-primary text-white font-bold px-4 py-4 w-full rounded-xl" 
        href={trackingUrl} target='blank'>LACAK PENGIRIMAN</a>
    </div>
  );


  const renderTimeline = () => (
    <div>
      <div className="font-bold mb-5">Riwayat Pengiriman</div>
      {
        history.map((item, i) => (
          <div className="flex flex-row" key={i}>
            <div className="w-10">
              {renderDot(history, i)}
            </div>
            <div className="flex flex-col flex-1 text-sm pb-10">
              <div className="text-gray-400 mb-1">{Lib.dateTime(item.date)}</div>
              <div>
                {item.title}
                <span className="mx-2 text-gray-400">&bull;</span>
                {item.description}
              </div>
            </div>
          </div>
        ))
      }
    </div>
  );



  return(
    visible &&
    <div className="fixed flex flex-col items-center top-0 bottom-0 left-0 right-0 z-10 bg-black bg-opacity-75" 
    onClick={handleClose}>

      <div className="bg-white w-full max-w-lg px-6 py-8 rounded-xl my-10 overflow-y-auto" 
        onClick={(e) => e.stopPropagation()}>

        <div className="flex flex-row items-center mb-5">
          <svg className="w-8 h-8 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 3V1.75C1.30964 1.75 0.75 2.30964 0.75 3L2 3ZM13 3H14.25C14.25 2.30964 13.6904 1.75 13 1.75V3ZM13 9V7.75C12.6685 7.75 12.3505 7.8817 12.1161 8.11612C11.8817 8.35054 11.75 8.66848 11.75 9H13ZM2 4.25H13V1.75H2V4.25ZM11.75 3V19H14.25V3H11.75ZM3.25 17V3H0.75V17H3.25ZM13 10.25H18V7.75H13V10.25ZM20.75 13V17H23.25V13H20.75ZM14.25 19L14.25 9H11.75L11.75 19H14.25ZM18.5303 19.5303C18.2374 19.8232 17.7626 19.8232 17.4697 19.5303L15.7019 21.2981C16.9711 22.5673 19.0289 22.5673 20.2981 21.2981L18.5303 19.5303ZM17.4697 18.4697C17.7626 18.1768 18.2374 18.1768 18.5303 18.4697L20.2981 16.7019C19.0289 15.4327 16.9711 15.4327 15.7019 16.7019L17.4697 18.4697ZM6.53033 19.5303C6.23744 19.8232 5.76256 19.8232 5.46967 19.5303L3.7019 21.2981C4.97111 22.5673 7.02889 22.5673 8.2981 21.2981L6.53033 19.5303ZM5.46967 18.4697C5.76256 18.1768 6.23744 18.1768 6.53033 18.4697L8.2981 16.7019C7.02889 15.4327 4.97111 15.4327 3.7019 16.7019L5.46967 18.4697ZM18.5303 18.4697C18.677 18.6164 18.75 18.8061 18.75 19H21.25C21.25 18.1702 20.9325 17.3363 20.2981 16.7019L18.5303 18.4697ZM18.75 19C18.75 19.1939 18.677 19.3836 18.5303 19.5303L20.2981 21.2981C20.9325 20.6637 21.25 19.8298 21.25 19H18.75ZM16 17.75H13V20.25H16V17.75ZM17.4697 19.5303C17.323 19.3836 17.25 19.1939 17.25 19H14.75C14.75 19.8298 15.0675 20.6637 15.7019 21.2981L17.4697 19.5303ZM17.25 19C17.25 18.8061 17.323 18.6164 17.4697 18.4697L15.7019 16.7019C15.0675 17.3363 14.75 18.1702 14.75 19H17.25ZM5.46967 19.5303C5.32298 19.3836 5.25 19.1939 5.25 19H2.75C2.75 19.8298 3.06755 20.6637 3.7019 21.2981L5.46967 19.5303ZM5.25 19C5.25 18.8061 5.32298 18.6164 5.46967 18.4697L3.7019 16.7019C3.06755 17.3363 2.75 18.1702 2.75 19H5.25ZM13 17.75H8V20.25H13V17.75ZM6.53033 18.4697C6.67702 18.6164 6.75 18.8061 6.75 19H9.25C9.25 18.1702 8.93245 17.3363 8.2981 16.7019L6.53033 18.4697ZM6.75 19C6.75 19.1939 6.67702 19.3836 6.53033 19.5303L8.2981 21.2981C8.93245 20.6637 9.25 19.8298 9.25 19H6.75ZM20.75 17C20.75 17.4142 20.4142 17.75 20 17.75V20.25C21.7949 20.25 23.25 18.7949 23.25 17H20.75ZM18 10.25C19.5188 10.25 20.75 11.4812 20.75 13H23.25C23.25 10.1005 20.8995 7.75 18 7.75V10.25ZM0.75 17C0.75 18.7949 2.20507 20.25 4 20.25V17.75C3.58579 17.75 3.25 17.4142 3.25 17H0.75Z" 
              fill="#0E1823"/>
          </svg>
          <div className="text-lg font-bold flex-1">Lacak</div>
          <IconButton icon={<i className="fi fi-br-cross-small text-2xl"></i>} onClick={handleClose}/>
        </div>

        <div className="mb-10">
          <div className="flex flex-row mb-2 text-sm">
            <div className="text-gray-400 w-24">Kurir</div>
            <div className="font-bold">{courier}</div>
          </div>
          <div className="flex flex-row mb-2  text-sm">
            <div className="text-gray-400 w-24">No. Resi</div>
            <div className="font-bold cursor-pointer">
              {waybill} 
              <span><i className="fi fi-br-copy text-sm ml-1"></i></span>
            </div>
          </div>
          <div className="flex flex-row mb-2 text-sm">
            <div className="text-gray-400 w-24">Status</div>
            <div className="font-bold cursor-pointer">
              {shippingStatus} 
            </div>
          </div>
        </div>

        {driverName !== null && renderDriverInfo()}

        {
          history.length === 0 ?
          <div className="text-gray-400 italic text-sm font-bold">Riwayat pengiriman belum tersedia. Silakan cek secara berkala.</div> :
          renderTimeline()
        }

        {trackingUrl !== null && renderLiveTrackingButton()}

      </div>
    </div>
  );
}
export default TrackingDetail;